import { Typography } from "@mui/material";
import { Link } from "react-scroll";
import type { HeaderMenuItemProps } from "./types/HeaderMenuItemProps";
import { commonTypographyStyles } from "../utils";

export function HeaderMenuItem({ navItem }: HeaderMenuItemProps) {
  return (
    <Link
      to={navItem.id}
      smooth
      offset={-100}
      duration={500}
      style={{ textDecoration: "none" }}
      onClick={() => window.history.pushState(null, "", `#${navItem.id}`)}
    >
      <Typography sx={commonTypographyStyles}>{navItem.title}</Typography>
    </Link>
  );
}
